import React from 'react'
import { GiSaveArrow } from 'react-icons/gi'
import { Table } from '../../../../components/Table'
import { REPORT_STATUS_ENUM } from '../../../../types/enums'
import { ReportType } from '../../../../types/report'
import { getReportTranslatedStatus } from '../../../../utils/translate'
import {
  getNormalizeDate,
  getPathToReportFromHash,
} from '../../../../utils/utils'
import './ReportsTable.sass'

const COLUMNS = [
  {
    Header: 'Дата создания',
    accessor: 'startDatetime',
    Cell: (cellInfo: any) => {
      return getNormalizeDate(cellInfo.row.original?.startDatetime)
    },
  },
  {
    Header: 'Дата начала',
    accessor: 'periodStart',
    Cell: (cellInfo: any) => {
      return getNormalizeDate(cellInfo.row.original?.periodStart)
    },
  },
  {
    Header: 'Дата окончания',
    accessor: 'periodFinish',
    Cell: (cellInfo: any) => {
      return getNormalizeDate(cellInfo.row.original?.periodFinish)
    },
  },
  {
    Header: 'Статус',
    accessor: 'status',
    Cell: (cellInfo: any) => {
      return (
        <span>{getReportTranslatedStatus(cellInfo.row.values?.status)}</span>
      )
    },
  },
  {
    Header: 'Загрузить',
    accessor: 'protectedHash',
    Cell: (cellInfo: any) => {
      const pathToReport = getPathToReportFromHash(
        cellInfo.row.values?.protectedHash
      )
      const status = cellInfo.row.values?.status
      const isBlocked =
        status === REPORT_STATUS_ENUM.PROCESSING ||
        status === REPORT_STATUS_ENUM.ERROR
      if (isBlocked) {
        return null
      }
      return (
        <a
          href={pathToReport}
          className={'cell__link'}
          target='_blank'
          rel='noreferrer'
        >
          <GiSaveArrow />
        </a>
      )
    },
  },
]

interface ReportTableProps {
  reportsList: ReportType[]
}

export const ReportsTable: React.FC<ReportTableProps> = ({ reportsList }) => {
  const columns = React.useMemo(() => COLUMNS, []) as any
  const data = React.useMemo(() => reportsList, [reportsList])

  return <Table columns={columns} data={data} />
}
